module.exports = __webpack_public_path__ + "static/img/header1.c94b103.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header1.jpg
// module id = 1AA7
// module chunks = 1